export const GET_LIST = 'COMPONENTS/get_list';
export const UPDATE_PDF = 'COMPONENTS/UPDATE_PDF';

export const FORM_DATA = {
    text_color: '',
    fill_color: '',
    header_text_color: '',
    border_color: '',
    ordinance_paragraph: '',
  };

  export const TYPES = [
    { label: 'PUV', value: 'PUV'},
    { label: 'TRICYCLE', value: 'TRICYCLE'},
  ]
